import { makeSlug } from "@/utils/utils";
import { CollabType } from "./collaborators.type";
import type { AgenceType } from "../agence/agence.type";

// Return true if collab is an Estate Agent
export const collabIsAgent = (collabFunction: string) => !['Administratif', 'Assistante', 'Gestionnaire RBV', 'Gestionnaire'].includes(collabFunction)

// Collabs of the agency, or of all its member agencies on a group site
export const getAgenceCollabs = ({ isGroup, agences, collaborateurs }: Pick<AgenceType, 'isGroup' | 'agences' | 'collaborateurs'>): CollabType[] => {
  if (isGroup) {
    return agences?.reduce((acc, curr) => [
      ...acc,
      ...curr.collaborateurs
    ], [] as CollabType[]) || []
  }

  return collaborateurs || []
}

export const getCollabUrl = ({nom, prenom}: {nom: CollabType['nom'], prenom: CollabType['prenom']}) => `/agent-immobilier/${makeSlug(`${nom}-${prenom}`).toLocaleLowerCase()}`

// Return the collab function
export const getCollabFonction = (fonction: CollabType['fonction']) => {
  switch (fonction) {
    case 'Conseiller Achat-Vente':
    case 'Conseillère Achat-Vente':
      return {
        label: 'Conseiller Achat-Vente',
        value: 'achat-vente'
      }

    case 'Conseiller Location-Gestion':
    case 'Conseillère Location-Gestion':
      return {
        label: 'Conseiller Location-Gestion',
        value: 'location-gestion'
      }

    case 'Conseiller en investissement':
    case 'Conseillère en investissement':
      return {
        label: 'Conseiller en investissement',
        value: 'invest'
      }

    default:
      return {
        label: 'Conseiller Achat-Vente',
        value: 'achat-vente'
      }
  }
}